'use client';

import classNames from 'classnames';
import { useInView } from 'motion/react';
import { useRef } from 'react';

export default function BenefitCardAnimation({
  children
}: React.PropsWithChildren) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });

  return (
    <div
      ref={ref}
      className={classNames(
        'transition-[opacity,transform] duration-700 opacity-0 translate-y-[20%] [&.active]:opacity-100 [&.active]:translate-y-0',
        {
          active: isInView
        }
      )}
    >
      {children}
    </div>
  );
}
